import request from '../utils/request';

// 手机号码登录获取验证码
export function smsSend(params) {
    return request.MainService({
        url: '/ddilearner/v1/sms/send',
        method: 'post',
        data: params
    });
}

// 登录
export function login(params) {
    return request.MainService({
        url: '/ddilearner/v1/user/login',
        method: 'post',
        data: params
    });
}

// 登出
export function logout(params,type) {
    return request.MainService({
        url: '/ddilearner/v1/user/logout?type=' + type,
        method: 'get',
        params: params
    });
}

// 判断是否多设备同时登陆
export function userinfo(params) {
    return request.MainService({
        url: '/ddilearner/v1/user/userinfo',
        method: 'get',
        params: params
    });
}

// 企业内容配置
export function enterpriseContent() {
    return request.MainService({
        url: '/ddilearner/v1/enterpriseContent',
        method: 'get'
    });
}

/**
 * 获取心跳间隔
 */
export function intervalValue() {
    return request.MainService({
        url: '/ddilearner/v1/user/loginstatus/interval',
        method: 'get',
        data: {}
    });

}

/**
 * 获取用户第一次访问信息
 * @param onceValue: Number  记录类型（-9999：应用工具引导上新）
 * @returns {AxiosPromise}
 */
export function getOnceInfo(onceValue) {
  return request.MainService({
    method: 'get',
    'url': '/sr/onceino/' + onceValue,
    data: {}
  })
}

/**
 * 记录用户第一次访问信息
 * @param onceValue: Number  记录类型（-9999：应用工具引导上新）
 * @returns {AxiosPromise}
 */
export function setOnceInfo(onceValue) {
  return request.MainService({
    method: 'post',
    'url': '/sr/onceino/' + onceValue,
    data: {}
  })
}

/**
 * 通过userId获取userName
 * @param userId: Number    用户Id
 */
export function getUserName(userId){
  return request.MainService({
    method: 'GET',
    'url': '/ddilearner/v1/user/getUserName?userId=' + userId
  })
}

// 校验当前帐号的密码账号异常信息(等保校验)
export function validateProtectionAccount(params) {
  return request.MainService({
    url: '/ddilearner/v1/user/validateProtectionAccount',
    method: 'post',
    data: params
  });
}

/**
 * 拉取登录图形验证码（二进制 PNG）
 * 一般直接用 img src=/ddilearner/v1/user/captcha?namespace=；需要 blob 时再调本方法
 */
export function fetchLoginCaptcha(namespace) {
  return request.MainService({
    url: '/ddilearner/v1/user/captcha',
    method: 'get',
    params: { namespace },
    responseType: 'blob'
  });
}

/**
 * 强制修改登录密码
 * @param {Object} params - 仅 currentPassword、newPassword（均需加密）
 */
export function updatePassword(params) {
  return request.MainService({
    url: '/ddilearner/v1/user/updatePassword',
    method: 'post',
    data: params
  });
}

//检测用户权限
export function checkAuthority(){
  return request.MainService({
    url: `/ddilearner/v1/checkAuthority`,
    method: 'get'
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js